import "App.scss";
import { Footer } from "components/Footer";
import { Navbar } from "components/NavBar";
import { SEO } from "components/SEO";
import { Buymeacoffee } from "components/SupportButton";
import { ScrollToTop } from "components/ScrollToTop";
import { EventType } from "constants/constant";
import { NavbarOption } from "constants/enum";
import { Routes } from "constants/routes";
import { useEffect } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import { RedirectPage } from "RedirectPage";
import { NotFoundPage } from "views/NotFoundPage";
import { FunFactPage } from "views/FunFactPage";
import { Analytics } from "utils/analytics";

const App = () => {
  const location = useLocation();

  useEffect(() => {
    Analytics.track(EventType.PAGE_VIEW, {
      page: location.pathname,
      search: location.search,
    });
  }, [location]);

  return (
    <div id="app-wrapper" key={location.key}>
      <SEO />
      <Navbar option={NavbarOption.WHITE} />
      <Switch>
        {Routes.map((route) => (
          <Route
            key={route.path}
            exact
            path={route.path}
            render={(props) => <route.component {...route.props} {...props} />}
          />
        ))}
        <Route path={"/blogs/leh-2023"}>
          <RedirectPage to="https://medium.com/@kritkruaykitanon/ดูนกเอง-เลห์-ลาดัก-03f89175c3a9" />
        </Route>
        <Route exact path="/fun-fact" component={FunFactPage} />
        <Route component={NotFoundPage} />
      </Switch>
      <Footer />
      <Buymeacoffee />
      <ScrollToTop />
    </div>
  );
};

export default App;
